var _circle, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddNoteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 48,
    fill: "#E65C6C",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.0001 44.92H58.5801C57.6657 44.898 56.7654 44.6906 55.9335 44.3105C55.1016 43.9304 54.3554 43.3854 53.7403 42.7085C53.1251 42.0317 52.6537 41.237 52.3546 40.3727C52.0555 39.5084 51.9349 38.5923 52.0001 37.68V28L68.0001 44.92Z",
    fill: "url(#paint0_linear_542_12996)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M68.0001 48H58.5801C57.2745 47.9592 55.9901 47.6583 54.8023 47.1149C53.6144 46.5715 52.5469 45.7967 51.6622 44.8356C50.7775 43.8746 50.0935 42.7467 49.6501 41.518C49.2067 40.2893 49.0129 38.9845 49.0801 37.68V28H39.3201C37.8335 28.0209 36.3655 28.3344 35.0001 28.9226C33.6347 29.5109 32.3985 30.3623 31.3622 31.4284C30.3258 32.4944 29.5096 33.7542 28.9602 35.1357C28.4108 36.5172 28.1389 37.9934 28.1601 39.48V56.68C28.1389 58.1666 28.4108 59.6428 28.9602 61.0243C29.5096 62.4058 30.3258 63.6656 31.3622 64.7316C32.3985 65.7977 33.6347 66.6492 35.0001 67.2374C36.3655 67.8256 37.8335 68.1391 39.3201 68.16H56.8401C58.3267 68.1391 59.7946 67.8256 61.1601 67.2374C62.5255 66.6492 63.7617 65.7977 64.798 64.7316C65.8343 63.6656 66.6505 62.4058 67.1999 61.0243C67.7494 59.6428 68.0212 58.1666 68.0001 56.68V48Z",
    fill: "url(#paint1_linear_542_12996)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_542_12996",
    x1: 51.9829,
    y1: 36.46,
    x2: 68.0001,
    y2: 36.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7E5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E65CA7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_542_12996",
    x1: 28.1589,
    y1: 48.08,
    x2: 68.0012,
    y2: 48.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7E5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E65CA7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddNoteIcon);
export default __webpack_public_path__ + "static/media/add-note-icon.68eecc7ec3543af0172f2da21caddd17.svg";
export { ForwardRef as ReactComponent };